<template>
  <o-view>
    <o-nav-bar title="Reisinfo" :has-back-button="true" />
    <o-block-list :padding="false">
      <o-section :smallPadding="true">
        <o-text-input
          placeholder="Vertrek"
          value="Antwerpen-Centraal"
          icon="start"
        />
      </o-section>
      <o-section :smallPadding="true">
        <o-text-input
          placeholder="Aankomst"
          value="Gent-Sint-Pieters"
          icon="destination"
        />
      </o-section>
    </o-block-list>
    <o-block-list title="Opties" :padding="false">
      <o-section :smallPadding="true">
        <o-text-input icon="date" value="2018-10-26" type="date" />
      </o-section>
      <o-section :smallPadding="true">
        <o-tab-switch name="retour" :items="['Enkel', 'Heen en terug']" />
        <o-tab-switch name="klas" :items="['1ste klas', '2de klas']" />
      </o-section>
    </o-block-list>
    <o-button
      to="/sales/train/nmbs/ticket"
      label="Tickets zoeken"
      :is-primary="true"
      :is-floating="true"
    />
  </o-view>
</template>

<script>
export default {
  name: 'NMBS1'
}
</script>
